import { render, staticRenderFns } from "./DataLoadTable.vue?vue&type=template&id=4c5ed666&"
import script from "./DataLoadTable.vue?vue&type=script&lang=js&"
export * from "./DataLoadTable.vue?vue&type=script&lang=js&"
import style0 from "./DataLoadTable.vue?vue&type=style&index=0&id=4c5ed666&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports